import script from "./FinancialOpp.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancialOpp.vue?vue&type=script&setup=true&lang=js"

import "./FinancialOpp.vue?vue&type=style&index=0&id=1e932ff0&lang=scss&scoped=true"
import "./FinancialOpp.vue?vue&type=style&index=1&id=1e932ff0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e932ff0"]])

export default __exports__